import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Kbd } from "@/components/ui/kbd";
import { isMac } from "../utils/use-keyboard-shortcuts";

interface KeyboardShortcutsHelpModalProps {
  open: boolean;
  onClose: () => void;
}

const shortcuts = [
  {
    keys: isMac() ? ["⌘", "Enter"] : ["Ctrl", "Enter"],
    description: "Save response and move to next",
  },
  {
    keys: ["Escape"],
    description: "Reset changes to original state",
  },
  {
    keys: isMac() ? ["⌘", "→"] : ["Ctrl", "→"],
    description: "Skip to next response",
  },
  {
    keys: isMac() ? ["⌘", "←"] : ["Ctrl", "←"],
    description: "Go to previous response",
  },
  {
    keys: ["↑", "↓"],
    description: "Navigate through themes in dropdown",
  },
  {
    keys: ["←", "→"],
    description: "Cycle sentiment (when theme is highlighted)",
  },
  {
    keys: ["Backspace"],
    description: "Remove selected theme",
  },
];

export const KeyboardShortcutsHelpModalModern: React.FC<
  KeyboardShortcutsHelpModalProps
> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Keyboard Shortcuts</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          {shortcuts.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-between gap-4 text-sm"
            >
              <span className="text-muted-foreground flex-1">
                {item.description}
              </span>
              <div className="flex items-center gap-1">
                {item.keys.map((key, keyIndex) => (
                  <React.Fragment key={keyIndex}>
                    <Kbd>{key}</Kbd>
                    {keyIndex < item.keys.length - 1 && (
                      <span className="text-muted-foreground text-xs">+</span>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
